module.exports = __webpack_public_path__ + "static/media/22_tn.4d62ac1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/22_tn.jpg
// module id = 658
// module chunks = 0